(() => {
  const ROOT_SELECTOR = '[data-tvati-media-press]';

  const initMediaPress = (root) => {
    if (!root || root.dataset.tvatiMediaPressReady === 'true') return;
    root.dataset.tvatiMediaPressReady = 'true';

    root.querySelectorAll('[data-youtube-fallback]').forEach((image) => {
      if (image.dataset.tvatiYoutubeFallbackReady === 'true') return;
      image.dataset.tvatiYoutubeFallbackReady = 'true';

      const useFallback = () => {
        const fallback = image.dataset.youtubeFallback;
        if (!fallback || image.dataset.tvatiYoutubeUsingFallback === 'true') return;

        image.dataset.tvatiYoutubeUsingFallback = 'true';
        image.src = fallback;
      };

      image.addEventListener('error', useFallback, { once: true });

      image.addEventListener(
        'load',
        () => {
          if (
            image.dataset.tvatiYoutubeUsingFallback !== 'true' &&
            (image.naturalWidth <= 200 || image.naturalHeight <= 120)
          ) {
            useFallback();
          }
        },
        { once: true }
      );

      if (
        image.complete &&
        image.naturalWidth > 0 &&
        (image.naturalWidth <= 200 || image.naturalHeight <= 120)
      ) {
        useFallback();
      }
    });

    root.querySelectorAll('[data-tvati-media-play]').forEach((button) => {
      if (button.dataset.tvatiMediaPlayReady === 'true') return;
      button.dataset.tvatiMediaPlayReady = 'true';

      button.addEventListener('click', () => {
        const videoId = button.dataset.videoId;
        if (!videoId) return;

        const iframe = document.createElement('iframe');
        iframe.src =
          `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}` +
          '?autoplay=1&rel=0&modestbranding=1';
        iframe.title =
          button.getAttribute('aria-label')?.replace(/^Play\s+/i, '') ||
          'YouTube video';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';

        button.replaceChildren(iframe);
        button.classList.add('is-playing');
        button.removeAttribute('data-tvati-media-play');
        button.removeAttribute('aria-label');
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initMediaPress);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
